export enum RangeSelectorType {
  Week = '7d',
  Month = '1m',
  SixMonths = '1y',
}
